<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
    >
      <template v-slot:activator="{ on }">
        <v-btn
          class="btn-settings"
          color="gray"
          dark
          fab
          top
          right
          fixed
          v-on="on"
        >
          <v-icon>mdi-cog-outline</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <!-- <v-list-item>
            <v-layout
              justify-left
              style="text-transform: normal;"
              wrap
            >
              <v-flex
                xs12
              >
                <v-icon>mdi-account</v-icon><span style="margin-left:15px">{{ userName }}</span>
              </v-flex>
              <v-flex
                xs12
                style="padding: 15px 0;"
              >
                <select-enterprise
                />                
              </v-flex>
            </v-layout>
          </v-list-item>
          <v-divider /> -->
          <v-list-item>
            <v-layout
              justify-center
              style="text-transform: uppercase;"
            >
              {{ $t('common.language')}}
            </v-layout>
          </v-list-item>
          <v-list-item>
            <v-layout
              justify-center
              style="text-transform: uppercase;"
            >
              <v-btn class="mr-4" :color="enterpriseColor" text @click="handleChangeLocale('es')">ESPAÑOL</v-btn><v-btn class="mr-4" :color="enterpriseColor" text @click="handleChangeLocale('en')">ENGLISH</v-btn>              
            </v-layout>
          </v-list-item>
          <v-divider />
          <v-list-item>
            <change-password
              :onChangeMessage="handleChangeMessage"
            />
          </v-list-item>
          <v-divider />
          <v-list-item>
            <v-btn
              block
              color="secondary"
              dark
              @click="handleLogout"
            >
              {{ $t('dashboard.logout') }}
            </v-btn>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <v-snackbar
      top
      right
      v-model="snackbar"
      :timeout="timeout"
      :color="messageColor"
    >
      {{ message }}
      <v-btn
        color="black"
        text
        @click="snackbar = false"
      >
        {{ $t('common.close') }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import i18n from '@/plugins/i18n'
  import ChangePassword from './ChangePassword'
  // import SelectEnterprise from './SelectEnterprise'
  export default {
    components: {
      ChangePassword,
      // SelectEnterprise
    },
    data: () => ({
      fav: true,
      menu: false,
      hints: true,
      snackbar: false,
      message: false,
      messageColor: 'success',
      timeout: 3000,

      enterprises: []
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      enterpriseName () {
        return this.$store.state.app.enterpriseName
      },
      userName () {
        return this.$store.state.app.userName
      },
      isAdmin () {
        return this.$store.state.app.isAdmin
      }
    },
    methods: {
      handleLogout () {
        this.$router.push('/login')
      },
      handleChangeLocale (locale) {
        i18n.locale = locale
      },
      handleChangeMessage (msg, color) {
        this.message = msg
        this.messageColor = color
        this.snackbar = true
      }
    }
  }
</script>

<style>
  .btn-settings {
    opacity: 0.4;
    margin-top: 0px;
    margin-right: -15px;
    border-radius: 15px 0 0 15px;
  }
</style>
